import script from "./PromotionView.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionView.vue?vue&type=script&setup=true&lang=js"

import "./PromotionView.vue?vue&type=style&index=0&id=26220eb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26220eb6"]])

export default __exports__